import { Routes } from '@angular/router';
import { configurationRoutes } from './configuration/configuration.routes';
import { contactsRoutes } from './contacts/contacts.routes';
import { usersRoutes } from './users/users.routes';

/** All routes for the standalone (non-Epic) SPA build. */
export const standaloneRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'contacts' },
  { path: 'loading', pathMatch: 'full', redirectTo: 'contacts' },
  ...contactsRoutes,
  ...usersRoutes,
  ...configurationRoutes,
  { path: '**', redirectTo: 'contacts' },
];
